export const DEFAULT_MENU_COLLAPSED_WIDTH = 68;

export const SIDE_CONTENT_COLLAPSED_WIDTH = 68;
export const SIDE_CONTENT_SMALL_WIDTH = 360;
export const SIDE_CONTENT_MEDIUM_WIDTH = 420;
export const SIDE_CONTENT_MEDIUM_BREAKPOINT = 1200;

export const LAYOUT_CONTENT_SCROLL_EMIT_TAG = "mainScroll";

export const COMPACT_LAYOUT_BREAKPOINT = 1000;

export const HEADER_BREAKPOINT = 860;

export const HEADER_HEIGHT_SMALL = 64;
export const HEADER_HEIGHT_LARGE = 64;
